import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { saveFileFromResponse } from '../../../utils/fileUtils';
import { showErrorToast } from '../../../utils/toastUtils';
import { getFinalizedClientPackageDocumentsZipArchive } from '../../generated/client';

export const useDownloadClientPackage = (): UseMutationResult<AxiosResponse, AxiosError, number> => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: async (clientPackageId) =>
            (await getFinalizedClientPackageDocumentsZipArchive({ path: { id: clientPackageId }, responseType: 'arraybuffer' })) as AxiosResponse,
        onSuccess: (response) => {
            const axiosResponse = response as AxiosResponse<string>;
            saveFileFromResponse(axiosResponse);
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureDocumentDownload') }),
    });
};
